<template>
  <v-container>
    <h2>新增服務範圍</h2>
    <div class="map-block">
      <google-map editable="editable" :zoom="range.zoom" :paths.sync="paths" :stations="stations" :center="range.position">
        <template slot="add-polygon">
          <v-btn>新增服務範圍</v-btn>
        </template>
        <template slot="remove-polygon">
          <v-btn>重置</v-btn>
        </template>
      </google-map>
    </div>
    <p>經緯度 (paths)：{{ paths }}</p><br/>
    <h2>顯示服務範圍</h2>
    <div class="map-block">
      <v-btn @click="showPolygon">顯示服務範圍</v-btn>
      <v-btn @click="finishShowPolygon">結束顯示服務範圍</v-btn>
      <google-map :zoom="range.zoom" :paths="insertPaths" :stations="stations" :center="range.position"></google-map>
    </div>
    <p>經緯度 (insertPaths)：{{ insertPaths }}</p><br/>
    <h2>顯示且編輯服務範圍</h2>
    <div class="map-block">
      <v-btn @click="showPolygon">顯示服務範圍</v-btn>
      <v-btn @click="finishShowPolygon">結束顯示服務範圍</v-btn>
      <v-btn @click="editPolygon">編輯服務範圍</v-btn>
      <v-btn @click="finishEditPolygon">完成編輯</v-btn>
      <google-map :zoom="range.zoom" :editable="editable" :paths.sync="insertPaths" :stations="stations" :center="range.position"></google-map>
    </div>
    <p>經緯度 (insertPaths)：{{ insertPaths }}</p>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import GoogleMap from '@/components/GoogleMap'
import EditPolygon from '@/mixins/EditPolygon'
import InsertPolygon from '@/mixins/InsertPolygon'

export default {
  mixins: [InsertPolygon, EditPolygon],
  components: { GoogleMap },
  data () {
    return {
      paths: []
    }
  },
  computed: {
    ...mapGetters({
      stations: 'station/list',
      range: 'range/data'
    })
  }
}
</script>

<style lang="stylus" scoped>
  .map-block
    display flex
    flex-direction column
    height 800px
</style>
